var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTethering1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.06 12.9c-.59-.59-1.54-.59-2.13 0 -.59.58-.59 1.52 0 2.1 .58.58 1.53.58 2.12 0 .58-.59.58-1.53 0-2.11Zm-3.54-1.42c1.36-1.37 3.58-1.37 4.94 0 1.36 1.36 1.36 3.57 0 4.93 -1.37 1.36-3.59 1.36-4.95 0 -1.37-1.37-1.37-3.58 0-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.71 10.26c-2.06-2.05-5.38-2.05-7.43 0 -2.05 2.03-2.05 5.34 0 7.38l-1.42 1.41c-2.84-2.83-2.84-7.4 0-10.22 2.83-2.82 7.41-2.82 10.25 0 2.83 2.82 2.83 7.39 0 10.21l-1.42-1.42c2.04-2.04 2.04-5.35 0-7.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.36 7.62c-3.52-3.51-9.22-3.51-12.74 0C2.1 11.11 2.1 16.78 5.61 20.28l-1.42 1.41c-4.3-4.28-4.3-11.23 0-15.51 4.29-4.28 11.25-4.28 15.55 0 4.29 4.27 4.29 11.22 0 15.5l-1.42-1.42c3.51-3.5 3.51-9.168 0-12.67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTethering1);
export default __webpack_public_path__ + "static/media/tethering 1.c9e0d652cf51efa0ed94fff6c924767c.svg";
export { ForwardRef as ReactComponent };